var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"options":_vm.lists,"filterable":false,"getOptionLabel":function (option) { return option[this$1.label]; }},on:{"search":_vm.onSearch,"search:focus":_vm.onFocus,"option:selected":_vm.onSelected,"option:deselected":_vm.onSelected},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}
var staticRenderFns = []

export { render, staticRenderFns }